export const SET_VIEW_ALL = 'SET_VIEW_ALL';
export const SET_SHOP_TYPE_FILTER = 'SET_SHOP_TYPE_FILTER';